import { Button } from "antd";
import React, { FC } from "react";
import "../../pages/Order/OrderDetails.css";

interface IButtonsProps {
	button1Text: string;
	button2Text: string;
	onButton2Click?: () => void;
	onButton1Click?: () => void;
	disabled?: boolean;
	firstButtonDisabled?: boolean;
}

const Buttons: FC<IButtonsProps> = ({
	button1Text,
	button2Text,
	onButton2Click,
	onButton1Click,
	disabled,
	firstButtonDisabled,
}) => {
	return (
		<div className="flex flex-row  w-full items-center md:flex-row md:gap-5 flex-col xl:flex flex-wrap gap-5 justify-end">
			<Button
				className="button1"
				onClick={onButton1Click}
				disabled={firstButtonDisabled}
			>
				{button1Text}
			</Button>
			<Button
				className="button2"
				onClick={onButton2Click}
				disabled={disabled}
			>
				{button2Text}
			</Button>
		</div>
	);
};

export default Buttons;
